import { render, staticRenderFns } from "./LiquidacionReportesPageLayout.vue?vue&type=template&id=0e0c583a&"
import script from "./LiquidacionReportesPageLayout.vue?vue&type=script&lang=js&"
export * from "./LiquidacionReportesPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports